import { Message } from 'element-ui'
import { popScreenWithOutOutbound } from '@/assets/js/wincall-init/index.js'
import i18n from '@/i18n'
/**
* 判断字符串中是否存在*号， 存在返回 TRUE; 否则返回 FALSE
*/
const exist_star = function (str) {

  if (str && str.indexOf('*') > -1) {
    return true;
  }

  return false;
}

/**
* 打电话
* phone_num 号码
* from_file 字段： 如果存在from_file 直接从from_file 中去取得号码，如果from_file 取得的号码有*号 那么用phone_num
**/
const dialByTabMessage = function (phone_num) {
  if (phone_num == '') {
    return false;
  }
  if (arguments[1]) {
    var from_file = arguments[1];
    var tmp_phone_num = $('#' + from_file).val();
    if (tmp_phone_num) {
      //号码中带有*号
      if (exist_star(tmp_phone_num)) {
        if (phone_num) {
          var diff = parseInt(tmp_phone_num.length) - parseInt(phone_num.length);
          var start_str = tmp_phone_num.substr(0, 1);
          if (diff == 1 && start_str == "0") {
            phone_num = "0" + phone_num;
          }
        }
      }
      else {
        phone_num = tmp_phone_num;
      }
    }
  }

  if (arguments[2]) {
    dial(phone_num, arguments[2]);
  } else {
    dial(phone_num);
  }
}

/**
*外呼函数
*@phone_num 外呼号码
*@outCaller 外呼主叫号码
*@_chan 外呼通道
**/
const dial = function (phone_num) {
  if (phone_num == '') {
    return;
  }

  if (window.cti === undefined || window.cti.Agent === undefined) {
    popScreenWithOutOutbound(phone_num)
    return;
  }

  var userData = '';
  if (arguments[1]) {
    userData = JSON.stringify(arguments[1]);
  }

  var callerID = cti.config.getState("callerID");

  if (callerID === '自动选择' || callerID === 'Auto') {
    callerID = '';
  }

  cti.Agent.callOut({ tel: phone_num, callerID: callerID, userData: userData, queueId: cti._queue }, (resp) => {
    if (resp.code === 0) {
      cti.SipPhone && cti.SipPhone.startTone();
    } else {
      popScreenWithOutOutbound(phone_num)
      Message(resp.message);
    }
  });
}

export default {
  dialByTabMessage, dial
}



// WEBPACK FOOTER //
// ./src/utils/signal.js